import {QueryClient, useQuery, UseQueryResult} from '@tanstack/react-query';
import { useSessionStore, SessionInfo } from '../state/sessionStore';
import { ApiEndpointEnum } from '@/enums/ApiEndpointEnum';
import useApiFetch from './useApiFetch';
import {getRequest} from "@/utils/apiUtils";

export function useSessionInfoQuery(): UseQueryResult<SessionInfo> {
  const setCsrf = useSessionStore((s) => s.setCsrf);
  const setIsGuest = useSessionStore((s) => s.setIsGuest);
  const { get } = useApiFetch();
  return useQuery<SessionInfo>({
    queryKey: ['sessionInfo'],
    queryFn: async ({ signal }) => {
      const info = await get(ApiEndpointEnum.SessionInfo, undefined, signal) as SessionInfo;
      // Update the store for persistence
      setCsrf(undefined, info?.csrfTokenValue);
      setIsGuest(info?.isGuest);
      return info;
    },
    staleTime: 60_000,
  });
}

export async function prefetchSessionInfo(queryClient: QueryClient) {
  await queryClient.prefetchQuery({
    queryKey: ['sessionInfo'],
    queryFn: async () => {
      // Using existing fetchJSON here is avoided to align with useApiFetch; however, hooks can't be used here.
      // We will perform a simple fetch using the same endpoint.
      const res = await fetch(getRequest(ApiEndpointEnum.SessionInfo));
      const info = (await res.json()) as SessionInfo;
      useSessionStore.getState().setCsrf(undefined, info?.csrfTokenValue);
      useSessionStore.getState().setIsGuest(info?.isGuest);
      return info;
    },
    staleTime: 60_000,
  });
}
